import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';

import styles from './ModalSubscription.module.scss';

const ModalSubscription = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const [searchParams] = useSearchParams();
  const modalType = searchParams.get('modal');
  const { isMobile } = useGlobal();

  const modalContent = (() => {
    const [, mode] = (modalType ?? '').split('-');
    if (mode === 'off') {
      return {
        primary: 'subscription:subscriptionOffPrimary',
        secondary: 'subscription:subscriptionOffSecondary',
        button: 'subscription:subscriptionButton',
      };
    } else {
      return {
        primary: 'subscription:subscriptionOnPrimary',
        secondary: 'subscription:subscriptionOnSecondary',
        button: 'subscription:subscriptionButton',
      };
    }
  })();

  return (
    <Modal
      isShow={true}
      className={styles.modalSubscription__body}
      onBackdropDismiss={() => closeModal()}
    >
      <div className={styles.modal}>
        <button
          onClick={() => closeModal()}
          className={classes(['button _no-padding', styles.close])}
        >
          <Icon type="close" size={isMobile ? 32 : 24} />
        </button>
        <div className={styles.imageContainer}>
          <img
            src={company.images.waitlist.empty}
            alt=""
            className={styles.image}
          />
        </div>
        <div className={styles.block}>
          <p className={styles.title}>{t(modalContent.primary)}</p>
          <p className={styles.description}>
            <Trans i18nKey={modalContent.secondary} t={t} />
          </p>
          <button
            className={classes(['button _primary _m', styles.action])}
            onClick={() => closeModal()}
          >
            {t(modalContent.button)}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default observer(ModalSubscription);
